//Configuration
export const appID = '104596_authe_app'
export const WEB_OAUTH_CLIENT = 'ForgeRockSDKClient'
export const ENVIRONMENT_VARIABLES = {
  local: {
    LOGIN_APP_URL: 'http://localhost:9000/',
    FR_URL: 'https://fr.sit.authe.dev.aws.jpmchase.net/openam',
    PING_URL: 'https://pf.sit.authe.dev.aws.jpmchase.net',
    SELF_ENROLL_URL: 'https://share-uat.jpmorgan.com/enroll/',
  },
  sit: {
    LOGIN_APP_URL: 'https://gxa-90612-202305111944-dev-glb.jpmchase.net/',
    FR_URL: 'https://fr.sit.authe.dev.aws.jpmchase.net/openam',
    PING_URL: 'https://pf.sit.authe.dev.aws.jpmchase.net',
    SELF_ENROLL_URL: 'https://share-uat.jpmorgan.com/enroll/',
  },
  uat: {
    LOGIN_APP_URL: 'https://share-preview-uat.jpmorgan.com/',
    FR_URL: 'https://aws-authe.uat.jpmorgan.com/openam',
    PING_URL: 'https://access-aws-authe.uat.jpmorgan.com',
    SELF_ENROLL_URL: 'https://share-uat.jpmorgan.com/enroll/',
  },
  prod: {
    LOGIN_APP_URL: 'https://share.jpmorgan.com/',
    FR_URL: 'https://aws-authe.jpmorgan.com/openam',
    PING_URL: 'https://access-aws-authe.jpmorgan.com',
    SELF_ENROLL_URL: 'https://share.jpmorgan.com/enroll/',
  },
}

//Journeys
export const LOGIN_JOURNEY = '104596_core-journey_v1.2'
export const FORGOT_USERNAME_JOURNEY = '104596_forgot-username_v1.2'
export const FORGOT_PASSWORD_JOURNEY = '104596_forgot-password_v1.2'

// ForgeRock stages for various 'Login' authentication step
export const FORGEROCK_LOGIN_STAGES = {
  LOGIN_USERNAME_PASSWORD: 'login-username-password',
  LOGIN_DEVICE_PROFILE: 'login-device',
  LOGIN_OTP_DELIVERY_CHANNEL: 'login-otp-delivery',
  LOGIN_COLLECT_OTP: 'login-otp-collector',
  LOGIN_RESET_PASSWORD: 'login-reset-password',
  LOGIN_USERNAME: 'login-username',
  LOGIN_PASSWORD: 'login-password',
}

//ForgeRock stages for various 'Forgot Password' authentication step
export const FORGEROCK_FORGOT_PASSWORD_STAGES = {
  FORGOT_PASSWORD_USERNAME: 'forgotpassword-username',
  FORGOT_PASSWORD_OTP_DELIVERY_CHANNEL: 'forgotpassword-otp-delivery',
  FORGOT_PASSWORD_COLLECT_OTP: 'forgotpassword-otp-collector',
  FORGOT_PASSWORD_RESET: 'forgotpassword-reset-password',
}

//ForgeRock stages for various 'Forgot Password' authentication step
export const FORGEROCK_FORGOT_USERNAME_STAGES = {
  FORGOT_USERNAME_USERNAME: 'forgotusername-username',
}

//ForgeRock error messages
export const INVALID_USERNAME_OR_PASSWORD = 'Invalid Username or Password'
export const INVALID_ONE_TIME_PASSWORD = 'Invalid One Time Password'
export const SOMETHING_WENT_WRONG = 'Something Went Wrong. Contact Us For More Info'

// ForgeRock specific params

export const TEXT_OUTPUT_CALLBACK = {
  INFORMATION: '0',
  WARNING: '1',
  ERROR: '2',
}

export const FR_SKIP_PASSWORD_PARAM_VALUE = 'Skip'

//APIs
export const ENVIRONMENT_VARIABLES_API = '/env'

/*
Mapping error codes from Janus to appropriate messages
Typo in password (PASSWRD_TOO_SHORT etc.) is also coming from Janus. Do not try to update it
*/
export const PASSWORD_RESET_ERRORS = {
  PASSWORD_TOTAL_LENGTH_OUT_OF_RANGE:
    'You must enter a password that is at least 8 characters and at maximum 127 characters in length.',
  PASSWORD_RECENTLY_USED: 'This previous password cannot be used. Please enter a new password.',
  PASSWRD_BAD_COMPOSITION: 'Bad composition of password, please check the password policy rules.',
  INVALID_ARGUMENT: 'The password does not meet the password policy requirements',
  PASSWRD_MISMATCH: 'The passwords entered do not match. Please re-enter your passwords.',
  PASSWRD_CONTAINS_PERSONAL_INFO:
    'Password must not contain your personal information like name, email etc.',
  PASSWORD_NOT_ALLOWED: 'Bad composition of password, please check the password policy rules.',
  PASSWORD_SEQ_SUBSTRING: 'Password has a substring of sequential characters.',
  PASSWORD_CONTAINS_NAME:
    'Password must not contain your personal information like name, email etc.',
  PASSWRD_CONTAINS_PERSONAL_INFORMATION:
    'Password must not contain your personal information like name, email etc.',
  PASSWORD_NUM_OF_RULES_MATCHED_BELOW_LIMIT: `Password doesn't match the specified complexity rules`,
  PASSWORD_DUP_SUBSTRING: 'Password has a substring of duplicate characters',
  NON_ASCII_CHARACTERS: 'Password contains invalid characters',
}

//Page Titles
export const LOGIN_TITLE = 'Share@JPMC | Secure Content Delivery Portal | JPMorgan Chase & Co.'
export const FORGOT_PASSWORD_TITLE =
  'Forgot Password | Secure Content Delivery Portal | JPMorgan Chase & Co.'
export const FORGOT_USERNAME_TITLE =
  'Forgot Username | Secure Content Delivery Portal | JPMorgan Chase & Co.'

//Headers
export const LOGIN_FORM_HEADER = 'Sign In'

//Disclaimers
export const SCD_DISCLAIMER =
  ' Unauthorized use of J.P. MORGAN' +
  "'" +
  'S websites and systems including but not\n' +
  'limited to unauthorized entry into J.P. MORGAN' +
  "'" +
  'S systems, misuse of passwords,\n' +
  'or misuse of any information posted to a site, is strictly prohibited.'

// Routes
export const LOGIN_ROUTE = '/'
export const FORGOT_USERNAME_ROUTE = '/forgotUsername'
export const FORGOT_PASSWORD_ROUTE = '/forgotPassword'
export const SESSION_EXPIRY_ROUTE = '/sessionExpire'
export const ENROLL_ROUTE = '/enroll'

// Messaging
export const SESSION_TIMEOUT_MESSAGE =
  'You have reached the maximum allowed time or an unknown error has occurred. Please click on Go to Login button.'

export const GENERIC_ERROR_MESSAGE_LINE1 = 'Please try again. '
export const GENERIC_ERROR_MESSAGE_LINE2 =
  'Contact your JPMorgan Chase representative if the problem persists. '
export const GENERIC_ERROR_MESSAGE_HEADING = 'Something went wrong'

export const USERNAME_REQUIRED_MESSAGE = 'Please enter username'
export const USEREMAIL_REQUIRED_MESSAGE = 'Please enter email address'
export const PASSWORD_REQUIRED_MESSAGE = 'Please enter password'
export const RESETPASSWORD_REQUIRED_MESSAGE = 'Please enter confirm password'
export const OTP_CHANNEL_REQUIRED_MESSAGE =
  "Please select how you'd like to receive this one-time access code"
export const OTP_REQUIRED_MESSAGE = 'Please enter your one-time access code'
export const OTP_ATTEMPTS_EXCEEDED_MESSAGE =
  'Exceeded maximum number of allowed attempts. Please try to log in after sometime.'

export const PASSWORD_MISMATCH =
  'The passwords entered do not match. Please re-enter your passwords.'

export const PASSWORD_CONTAINS_SPACES_MESSAGE =
  'Password must not contain leading or trailing spaces'

export const ABOUT_TO_EXPIRE_PASSWORD_MESSAGE = daysToPasswordExpiry =>
  `Your password is correct but will expire in ${daysToPasswordExpiry} day(s).
                                  You can change your password before proceeding or change it later.`

export const EXPIRED_PASSWORD_ERROR_MESSAGE =
  'Your password is correct but has expired. Please change your password before proceeding.'

export const INVALID_USERNAME_PASSWORD_SCD_ERROR = 'Login was unsuccessful. Please try again.'
export const INVALID_ONE_TIME_PASSWORD_SCD_ERROR = 'Invalid one-time access code. Please try again.'
export const SOMETHING_WENT_WRONG_SCD_ERROR =
  'Unable to Login. Please try after sometime or contact your JPMC representative.'
export const INVALID_EMAIL_ERROR = 'Please enter a valid email address'
export const JPMC_EMAIL_ERROR = 'Please do not use a JPMorgan Chase email address'
export const LOGIN_FAILURE_SCD_ERROR =
  'Something went wrong. Please try after sometime or contact your JPMC representative.'

export const COPYRIGHT_INFO = '2026 JPMorgan Chase & Co. All rights reserved.'

export const GO_TO_LOGIN_BUTTON_LABEL = 'Go to Login'

export const OTP_Label = 'Please enter the one-time access code'

export const SIT_ENV = 'sit'
export const DEV_ENV = 'dev'
export const UAT_ENV = 'uat'
export const PROD_ENV = 'prod'
export const LOGIN_APP_URL = 'LOGIN_APP_URL'
export const FR_URL = 'FR_URL'
export const PING_URL = 'PING_URL'
export const SELF_ENROLL_URL = 'SELF_ENROLL_URL'

export const SUPPORT_HEADERS = [{ children: 'Location' }, { children: 'Number' }]
export const SUPPORT_ROW_DATA = [
  {
    children: [
      { children: 'US & Canada' },
      { children: '1-800-477-0406, +1-212-682-2358 (Direct)' },
    ],
  },
  {
    children: [{ children: 'Australia' }, { children: '1-800-340869' }],
  },
  {
    children: [
      { children: 'Germany' },
      { children: '0 800 712 4200, +49 69 712 4200 (Outside Germany)' },
    ],
  },
  {
    children: [{ children: 'Hong Kong' }, { children: '800-961025' }],
  },
  {
    children: [{ children: 'Japan' }, { children: '0066-33-813291' }],
  },
  {
    children: [{ children: 'Singapore' }, { children: '800-1206711' }],
  },
  {
    children: [{ children: 'United Kingdom' }, { children: '0808-2346255' }],
  },
]
export const JPMC_EMAIL_PATTERN = new RegExp(
  /^[a-zA-Z0-9._-]+@(?=bear\.com|cazenove\.com|chase\.com|chasepaymentech\.com|firstusa\.com|highbridge\.com|jfam\.com|jpmchase\.com|jpmorgan\.com|jpmorgancazenove\.com|paymentech\.com|providian\.com|Securitycapital\.com|wamu\.com|restricted\.chase\.com|chasepaymentech\.ca|Wamu\.net|jpmchase\.net|jpmmps\.com).*$/
)

export const EMAIL_PATTERN = new RegExp(/\S+@\S+\.\S+/)
